// extracted by mini-css-extract-plugin
module.exports = {"parent":"CallLogsPanel_parent__11H1t"};